import { useState } from "react";
import { Monitor, Smartphone } from "lucide-react";
import { API } from "@/lib/api";

// Read-only preview: a frozen copy of the site draft in a sandboxed frame, or an example structure clearly labelled as not the site.
export default function ReviewPreview({ token, preview, grouped }) {
  const [device, setDevice] = useState("desktop");
  if (preview.kind !== "draft_snapshot") return (
    <div className="space-y-3" data-testid="review-placeholder">
      <div className="rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900" data-testid="review-placeholder-note">
        <p className="font-semibold">Il tuo sito non è ancora pronto</p>
        <p className="mt-1">Questa è solo la struttura delle pagine che hai scelto, non il sito. Puoi già dirci cosa vuoi vedere in ogni pagina.</p></div>
      {grouped.map(([page]) => (
        <div key={page} className="rounded-xl border border-dashed border-slate-300 bg-white p-4" aria-hidden="true">
          <p className="text-sm font-semibold text-slate-700">{page}</p>
          <div className="mt-3 space-y-2"><div className="h-3 w-2/3 rounded bg-slate-100" /><div className="h-3 w-1/2 rounded bg-slate-100" /><div className="h-16 rounded bg-slate-50" /></div>
        </div>))}
    </div>);
  return (
    <div className="flex h-full min-h-0 flex-col gap-2" data-testid="review-frame-wrap">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs text-slate-500">Bozza privata, non pubblicata: moduli e prenotazioni sono disattivati.</p>
        <div className="hidden shrink-0 rounded-full bg-slate-100 p-1 md:flex" role="group" aria-label="Dispositivo">
          {[["desktop", Monitor, "Computer"], ["mobile", Smartphone, "Telefono"]].map(([k, I, l]) => (
            <button key={k} type="button" onClick={() => setDevice(k)} aria-pressed={device === k} data-testid={`review-device-${k}`}
              className={`flex min-h-9 items-center gap-1.5 rounded-full px-3 text-xs ${device === k ? "bg-white text-slate-900 shadow-sm" : "text-slate-600"}`}><I size={14} />{l}</button>))}
        </div>
      </div>
      <div className="flex min-h-0 flex-1 justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-100">
        <iframe title="Anteprima del sito" sandbox="allow-scripts allow-popups" src={`${API}/public/client-review/${token}/frame`} data-testid="review-frame"
          className={`h-full min-h-[70vh] border-0 bg-white transition-[width] duration-300 ${device === "mobile" ? "w-[390px] max-w-full" : "w-full"}`} />
      </div>
    </div>);
}
